import React from "react";
import PendingItems from "../../../components/dashboard/pendingitem/pendingitems";
import AdvancedReports from "../../../components/dashboard/advancedreports/advancedreports";
import Tranding from "../../../components/dashboard/tranding/tranding";

const Overview = () => {
  return (
    <>
      <div className="w-full flex-col justify-start items-start gap-1.5 inline-flex pt-8 py-9">
        <h2 className="text-basePrimary text-3xl font-semibold  leading-9">
          Overview
        </h2>
        <div className="w-full">
          <span className="text-[#222222] text-base font-normal  leading-normal">
            Hi Shaher 👋
            <br />
            Welcome to the{" "}
          </span>
          <span className="text-secondary text-base font-semibold  leading-normal">
            NobleMarriage
          </span>
          <span className="text-[#222222] text-base font-normal  leading-normal">
            {" "}
            Admin Dashboard!
            <br />
            <br />
            Your hub for managing and enhancing user experiences starts here.
            Access key metrics, recent activities, and essential tasks to keep
            our platform running smoothly. Let's make every match a success!
          </span>
        </div>
      </div>
      <PendingItems />
      <AdvancedReports />
      <Tranding />
    </>
  );
};

export default Overview;
